import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { ymHit } from '../functions/metrika';

export default function useYandexMetrika() {
  const { pathname, search } = useLocation();
  const prevUrl = useRef(null);

  useEffect(() => {
    const url = window.location.href;

    // Хит для первой загрузки счётчик отправляет сам при init — не дублируем его.
    if (prevUrl.current === null) {
      prevUrl.current = url;
      return;
    }

    if (prevUrl.current === url) return;

    ymHit(url, prevUrl.current);
    prevUrl.current = url;
  }, [pathname, search]);
}
